import useZWR from "@/utils/use-zwr";
import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";

// POST /auth/register — Body___auth_register_post 기준.
// 인증번호 확인 때 받는 temp_token은 이 바디에서 빠졌다(단계 진입 게이트에만 쓴다).
export interface SignUpRequest {
  email: string;
  password: string;
  name: string;
  userInputedCompanyName: string;
  countryCode: string;
  mobileNumber: string;
  // 서버 기본값 false
  agreeToMarketing?: boolean;
  // 사업자등록증에서 읽어 사용자가 확인·수정한 값
  userInputedBusinessRegistrationNumber?: string | null;
  // 업로드한 사업자등록증 파일의 uno_file_id
  businessRegistrationCertificateFileId?: number | null;
  // 추천인. 선택 입력이라 미입력이면 아예 보내지 않는다.
  recommender?: string;
}

interface SignUpResponse {
  accessToken: string;
}

interface SignUpPathParameter {}

export const signUpTemplateUrl = `/auth/register`;
export const signUpKey: YWRKey<SignUpPathParameter> = {
  url: signUpTemplateUrl,
  method: "post",
};
export default function useSignUp() {
  const fetcher = useFetcher<SignUpRequest, SignUpResponse>();
  return useYWR(signUpKey, fetcher);
}
